import { render, staticRenderFns } from "./Shichi.vue?vue&type=template&id=2111625a&scoped=true&"
import script from "./Shichi.vue?vue&type=script&lang=js&"
export * from "./Shichi.vue?vue&type=script&lang=js&"
import style0 from "./Shichi.vue?vue&type=style&index=0&id=2111625a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111625a",
  null
  
)

export default component.exports